'use client';
import { GetDataIndexServices } from 'features/conge/services/Timeline';
import { FiltersTimeline } from 'features/conge/types/timeline';
import React, { useState } from 'react';
import LeaveRequestHeader from '../shared/LeaveRequestHeader';
import DateTimeLine from './DateTimeLine';
import Link from 'next/link';
import TypeConge from './TypeConge';
import Timeline from './Timeline';
import { useTranslation } from 'react-i18next';
import useFetchData from 'hooks/useFetch';
import moment, { Moment } from 'moment';

const IndexTimeLine: React.FC = () => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState<Moment>(moment());
  const [selectedTypes, setSelectedTypes] = useState<number[]>([]);
  const { data: dataIndex, refetch } = useFetchData(GetDataIndexServices, []);

  const [timeLinefilters, setTimeLineFilters] = useState<FiltersTimeline>({
    month: selectedDate.month(),
    year: selectedDate.year(),
    searchValue: '',
    lenght: 15,
    filter: [
      {
        filterName: 'TypeConge',
        filterValue: '',
      },
      {
        filterName: 'Departemant',
        filterValue: '',
      },
      {
        filterName: 'Sites',
        filterValue: '',
      },
      {
        filterName: 'Function',
        filterValue: '',
      },
      {
        filterName: 'society',
        filterValue: '',
      },
      {
        filterName: 'Teams',
        filterValue: '',
      },
    ],
  });
  return (
    <>
      <LeaveRequestHeader
        setTimeLineFilters={setTimeLineFilters}
        dataIndex={dataIndex}
        timeLineFilters={timeLinefilters}
        selectedDate={selectedDate}
        refetch={refetch}
        demandeCount={dataIndex?.demandeCount ?? 0}
        congeCount={dataIndex?.userInHolidayCount ?? 0}
      />
      <div className="tab-content minthr-mt-4">
        <div className="tab-pane fade show active">
          <div>
            <div className="minthr-flex minthr-flex-items-center minthr-flex-space-between minthr-mb-6 minthr-mobile-flex-wrap">
              <DateTimeLine
                setSelectedDate={setSelectedDate}
                setFilters={setTimeLineFilters}
              />

              <div className="minthr-flex minthr-flex-items-center minthr-ml-auto minthr-p-1 minthr-mobile-p-0 minthr-mobile-flex-wrap minthr-mobile-ml-0">
                <Link
                  href="/conge/demande?waiting=true"
                  className="minthr-flex minthr-flex-items-center minthr-badge minthr-badge-warning minthr-px-3 minthr-mobile-ml-0 minthr-mobile-mb-4 minthr-mobile-w-100"
                >
                  <img
                    className="minthr-icon-m minthr-icon-warning minthr-mr-2"
                    src="/icons/calendar.svg"
                    alt=""
                  />
                  <h5 className="minthr-color-dark minthr-mr-2">
                    {t('Conge.switch.link.demand')}
                  </h5>
                  <span className="minthr-color-warning minthr-mobile-ml-auto">
                    {dataIndex && dataIndex.demandeCount}
                  </span>
                  <img
                    className="minthr-icon-s minthr-icon-warning minthr-ml-2"
                    src="/icons/arrow3.svg"
                    alt=""
                  />
                </Link>

                <Link
                  href="/conge/demande"
                  className="minthr-flex minthr-flex-items-center minthr-badge minthr-badge-toxic minthr-px-3 minthr-ml-5 minthr-mobile-ml-0 minthr-mobile-mb-4 minthr-mobile-w-100"
                >
                  <img
                    className="minthr-icon-m minthr-icon-toxic minthr-mr-2"
                    src="/icons/archive.svg"
                    alt=""
                  />
                  <h5 className="minthr-color-dark minthr-mr-2">
                    {t('Timeline.Historique.demandes')}
                  </h5>
                  <img
                    className="minthr-icon-s minthr-icon-toxic minthr-ml-auto"
                    src="/icons/arrow3.svg"
                    alt=""
                  />
                </Link>
              </div>
            </div>
            <TypeConge
              setFilters={setTimeLineFilters}
              selectedTypes={selectedTypes}
              setSelectedTypes={setSelectedTypes}
            />

            <div id="calendarConges" className="minthr-calendar">
              <Timeline selectedDate={selectedDate} filters={timeLinefilters} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IndexTimeLine;
